/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessLabel
 */
export interface BusinessLabel {
    /**
     * 
     * @type {string}
     * @memberof BusinessLabel
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessLabel
     */
    value: string;
}

export function BusinessLabelFromJSON(json: any): BusinessLabel {
    return BusinessLabelFromJSONTyped(json, false);
}

export function BusinessLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
    };
}

export function BusinessLabelToJSON(value?: BusinessLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}


